
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IoIosWarning } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import LoadingSpinner from './LoadingSpinner';

import './title.scss';

function Title({title, loading, error, lastFetch}) {

  const { t } = useTranslation();
  return (
    <Row className="title align-items-baseline mb-3">
      <Col xs="auto">
        <h2>{title || t('title')}</h2>
      </Col>
      <Col className="ml-auto" xs="auto">
        {loading ? (
          <LoadingSpinner inline size={2} />
        ) : (
          <small className="text-muted">
            {error ? (
              <OverlayTrigger placement="top" overlay={<Tooltip>{error}</Tooltip>}>
                <IoIosWarning size="2em" className="react-icon--inline"/>
              </OverlayTrigger>
            ) : (
              lastFetch
                ? `${t('common.last-updated')}: ${moment(lastFetch).local().calendar() || ''}`
                : ""
            )}
          </small>
        )}
      </Col>
    </Row>
  );
}

export default Title;
